import { type Enum } from '@webapp/utils'

export const FinancialServices = {
  SPENDING_CARD: 'spending card',
} as const
export type FinancialService = Enum<typeof FinancialServices>
